import React from 'react';

function PromptArea({ textAreaValue, setTextAreaValue }) {
  return (
    <div className="prompt-area-container">
      <h5>Deine Bildvorstellung:</h5>
      <textarea 
        className="app-textarea" 
        placeholder="Beschreibe dein gewünschtes Motiv"
        value={textAreaValue}
        onChange={e => setTextAreaValue(e.target.value)}
      />
    </div>
  );
}

export default PromptArea;
